/**
 * `value` as a number, if it is a positive one. Numbers from the backend's
 * configuration can arrive as strings: Laravel's `env()` returns environment
 * variables unconverted.
 */
export function toPositiveNumber(value?: number | string): number | undefined {
    const parsed = Number(value);

    return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}
